// @ts-nocheck
// 7 AI Pillars — with v2 renames already applied.
// Each has: id, name, tagline, sidebarLabel, mediumDesc, demoAsset,
// pillarColor, icon (from icon registry), psychology.
//
// NOTE: The "survey" (Inquiry AI) pillar has been removed per v2 spec.
// Renames from data-patch-v2: progress → "AI Powered Student Information",
// childcare → "AI Child Care", feedback → "AI Feedback", helpdesk → "AI Parental Helpdesk".

export const PILLARS = [
  {
    id: "inspire",
    name: "Inspire 365",
    sidebarLabel: "Inspire 365",
    tagline: "Daily AI mindset podcasts for students.",
    icon: "sparkles",
    colorVar: "--pillar-inspire",
    color: "#7c3aed",
    tint: "rgba(124, 58, 237, 0.10)",
    kind: "AI Teacher",
    demoAsset: "3-min audio: 'Steel Mindset — overcoming fear of maths'",
    cadence: "Daily, 6:30 AM",
    psychology: "Carol Dweck · Growth Mindset · APJ Abdul Kalam",
    ranks: ["shy-child", "anxiety", "olympiad-track", "academic-focus"],
  },
  {
    id: "childcare",
    name: "AI Child Care",
    sidebarLabel: "AI Child Care",
    tagline: "44,000+ parenting issues, videos & podcasts.",
    icon: "parent",
    colorVar: "--pillar-childcare",
    color: "#db2777",
    tint: "rgba(219, 39, 119, 0.10)",
    kind: "Parent Support",
    demoAsset: "Video: 'Helping shy children find their voice'",
    cadence: "On-demand library",
    psychology: "Erik Erikson · Daniel Goleman · Manodarpan",
    ranks: ["shy-child", "first-school", "parenting-questions", "emotional-support"],
  },
  {
    id: "progress",
    name: "AI Powered Student Information",
    sidebarLabel: "AI Student Info",
    tagline: "Personalised holistic insights for every child.",
    icon: "student",
    colorVar: "--pillar-progress",
    color: "#1769ff",
    tint: "rgba(23, 105, 255, 0.10)",
    kind: "Student Intelligence",
    demoAsset: "Sample HPR: attendance · marks · behaviour · early warnings",
    cadence: "Weekly auto-update",
    psychology: "NEP 2020 HPR · Joyce Epstein partnership model",
    ranks: ["academic-focus", "board-prep", "high-performer", "discipline", "transferring"],
  },
  {
    id: "language",
    name: "Multilingual Comms",
    sidebarLabel: "Multilingual",
    tagline: "10+ Indian languages. IVR · SMS · WhatsApp · App.",
    icon: "language",
    colorVar: "--pillar-language",
    color: "#0891b2",
    tint: "rgba(8, 145, 178, 0.10)",
    kind: "Communication",
    demoAsset: "Sample notification — delivered in parent's language",
    cadence: "Real-time, 24×7",
    psychology: "Bhashini · Digital India",
    ranks: ["language-concern", "new-to-city", "first-school"],
  },
  {
    id: "feedback",
    name: "AI Feedback",
    sidebarLabel: "AI Feedback",
    tagline: "Quick surveys → actionable school reports.",
    icon: "comms",
    colorVar: "--pillar-feedback",
    color: "#16a34a",
    tint: "rgba(22, 163, 74, 0.10)",
    kind: "Parent Voice",
    demoAsset: "30-second survey + how last term's feedback was acted on",
    cadence: "Monthly + event-based",
    psychology: "Joyce Epstein · participation loops",
    ranks: ["transferring", "first-school"],
  },
  {
    id: "helpdesk",
    name: "AI Parental Helpdesk",
    sidebarLabel: "AI Helpdesk",
    tagline: "Ask anything. Research-backed answers.",
    icon: "command",
    colorVar: "--pillar-helpdesk",
    color: "#b45309",
    tint: "rgba(180, 83, 9, 0.10)",
    kind: "Parent Support",
    demoAsset: "Live Q&A: 'How do I support my anxious child before exams?'",
    cadence: "24×7 chat + IVR",
    psychology: "Goleman · John Bowlby · Manodarpan",
    ranks: ["anxiety", "emotional-support", "special-needs", "parenting-questions"],
  },
  {
    id: "survey",
    name: "Inquiry Response Engine",
    sidebarLabel: "Inquiry AI",
    tagline: "AI counsellor that captures & qualifies enquiries.",
    icon: "voice",
    colorVar: "--pillar-survey",
    color: "#0f766e",
    tint: "rgba(15, 118, 110, 0.10)",
    kind: "Admissions",
    demoAsset: "Demo call recording — multilingual AI counsellor",
    cadence: "24×7 across channels",
    psychology: "Bhashini · 100% enquiry capture",
    ranks: ["new-to-city", "language-concern", "transferring"],
  },
];
